import React from 'react';
import './SpeakerDescription.sass';
import ReactHtmlParser from 'react-html-parser';

type SpeakerChildItem = {
  readonly _id?: string;
  readonly _url?: string | null;
  readonly pageTitle?: string | null;
  readonly bio?: string | null;
  readonly speakerName?: string;
  readonly speakerPreviewDescription?: string | null;
  readonly speakerImage?: string;
  readonly location?: {
    readonly city?: string;
    readonly countryName?: string;
    readonly country?: {
      readonly _url?: string | null;
    };
  };
  readonly facebookLink?: string | null;
  readonly twitterLink?: string | null;
  readonly linkedinLink?: string | null;
};

type Props = {
  readonly currentSpeaker: SpeakerChildItem | null;
};

const SpeakerDescription: React.FC<Props> = ({ currentSpeaker }) => {
  const {
    bio,
    pageTitle,
  } = currentSpeaker || {};

  return (
    <div className="speaker-description">
      {pageTitle && (
        <h1 className="uikit-heading-lg speaker-description__heading">
          {ReactHtmlParser(pageTitle)}
        </h1>)}
      {bio && (
        <div className="speaker-description__text">
          {ReactHtmlParser(bio)}
        </div>)}
    </div>
  );
}

export default SpeakerDescription;
